
import { Settlement } from "@/types/payment";
import { Expense } from "@/types/expense";

/**
 * Type definition for cached settlement calculation
 */
export interface SettlementCalculationCache {
  expenses: Expense[];
  paidSettlements: Settlement[];
  result: Settlement[];
}

/**
 * Checks if current calculation inputs match the cached inputs
 * @param cache The cached calculation
 * @param expenses Current expenses
 * @param paidSettlements Current paid settlements
 * @returns Boolean indicating if cache can be used
 */
export const canUseCache = (
  cache: SettlementCalculationCache | null,
  expenses: Expense[],
  paidSettlements: Settlement[]
): boolean => {
  if (!cache) return false;
  
  return cache.expenses === expenses &&
         cache.paidSettlements === paidSettlements;
};

/**
 * Creates a new cache entry for a settlement calculation
 * @param expenses Expenses used in the calculation
 * @param paidSettlements Paid settlements used in the calculation
 * @param result The calculated settlements
 * @returns A new cache object
 */
export const createCacheEntry = (
  expenses: Expense[],
  paidSettlements: Settlement[],
  result: Settlement[]
): SettlementCalculationCache => {
  return {
    expenses,
    paidSettlements,
    result
  };
};
